import React, { useState, useEffect } from "react";
import { makeCdnUrl } from "motion-master-client";

const DownloadESI = ({ brandId, version }) => {
  const [url, setUrl] = useState("");
  const [fileName, setFileName] = useState(null);

  useEffect(() => {
    const sanitizedVersion = encodeURIComponent(version.replace(/^v/, ""));
    const file = `${sanitizedVersion}.xml`;

    const url = makeCdnUrl(`/brands/${brandId}/esis/${file}`);

    setFileName(file);
    setUrl(url);
  }, [brandId, version]);

  return (
    <>
      <a
        href={url}
        download={fileName}
        rel="noreferrer"
        className="dropdown-item"
        title="Download EtherCAT Slave Information file"
      >
        ESI File (.xml)
      </a>
    </>
  );
};

export default DownloadESI;
